export default __webpack_public_path__ + "static/area_6-69215422c5ee44e5a19e29f96bf13bb8.jpg";